import { render, staticRenderFns } from "./CalendarLoadingIcons.vue?vue&type=template&id=40fd0a4a&scoped=true&"
import script from "./CalendarLoadingIcons.vue?vue&type=script&lang=js&"
export * from "./CalendarLoadingIcons.vue?vue&type=script&lang=js&"
import style0 from "./CalendarLoadingIcons.vue?vue&type=style&index=0&id=40fd0a4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fd0a4a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VProgressCircular,
})
